<template>
  <footer id="footer">
    <LogoText />
    <div class="blocks">
      <div class="map-block">
        <p class="name">{{ links_name }}</p>
        <ul class="nav">
          <li v-for="link in links" :key="link.url">
            <router-link
              :data-page-type="link.type"
              :data-page-id="link.page_id"
              v-bind:to="{ path: link.url }"
              @click.native="handleRoute"
              >{{ link.name }}</router-link
            >
          </li>
        </ul>
      </div>

      <div class="newsletter-block">
        <div v-html="newsletter" class="newsletter"></div>

        <div class="social-media">
          <p class="name">Socials</p>

          <ul>
            <li v-for="link in socials" :key="link.url">
              <a target="_blank" :class="[link.key, 'icon']" :href="link.url">{{
                link.name
              }}</a>
            </li>
          </ul>
        </div>
      </div>

      <address class="contact-block"> <!-- contact w drugiej kolumnie -->
        <p class="name" :data-contact="contact_text">Headquarters</p>

        <div v-html="contact_data.address" class="part-address"></div>
        <div v-html="contact_data.phone" class="part-phone"></div>
        <div v-html="contact_data.info" class="part-info"></div>
      </address>
    </div>
  </footer>
</template>

<script>
import LogoText from "@/components/LogoText.vue";

export default {
  name: "Footer",
  components: {
    LogoText,
  },
  data() {
    return {
      socials: window.APP_INFO.init.footer_data.socials,
      newsletter: window.APP_INFO.init.footer_data.newsletter,
      contact_data: window.APP_INFO.init.footer_data.contact_data,
      contact_text: window.APP_INFO.trans.contact,
      links_name: window.APP_INFO.init.footer_data.links_name,
      links: window.APP_INFO.init.footer_data.links,
    };
  },
  methods: {
    handleRoute(e) {
      this.$emit("reload", {
        type: e.target.dataset.pageType,
        href: e.target.attributes.href,
        id: e.target.dataset.pageId,
      });
    },
  },
};
</script>


<style lang="scss">

    #footer .nav li a {
        border-color: transparent;
    }

</style>